import { StarIcon } from "@chakra-ui/icons";
import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { formatReadingOrderMeta } from "../helpers/discoverSections";

// Slightly wider than 3:2 so the rows take less vertical space on Browse.
export const DISCOVER_CARD_RATIO = 1.8;

/**
 * Compact cover card used in the swipeable discovery rows on Browse.
 * Mirrors the mobile DiscoverCard component.
 */
const DiscoverCard = ({ readingOrder, width, isPremium, onClick }) => {
  if (!readingOrder) {
    return null;
  }

  const height = Math.round(width / DISCOVER_CARD_RATIO);
  const premiumOnly = Boolean(
    readingOrder.paywallPremiumOnly ?? readingOrder.premiumOnly
  );
  const meta = formatReadingOrderMeta(readingOrder);

  return (
    <Box
      as={Link}
      to={`/browse/${readingOrder.id}/preview`}
      onClick={onClick}
      aria-label={`${readingOrder.title}. ${meta}`}
      display="block"
      position="relative"
      flexShrink={0}
      w={`${width}px`}
      h={`${height}px`}
      borderRadius="12px"
      overflow="hidden"
      bg="gray.700"
      scrollSnapAlign="start"
      transition="opacity 0.15s"
      _hover={{ opacity: 0.85 }}
      _focusVisible={{ boxShadow: "outline", outline: "none" }}
    >
      <Image
        src={readingOrder.thumbnail}
        alt=""
        w="100%"
        h="100%"
        objectFit="cover"
        draggable={false}
      />
      <Box
        position="absolute"
        left="0"
        right="0"
        bottom="0"
        h="70%"
        bgGradient="linear(to-b, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 20%, rgba(0,0,0,0.15) 40%, rgba(0,0,0,0.45) 60%, rgba(0,0,0,0.75) 80%, rgba(0,0,0,0.92) 100%)"
      />
      {!isPremium && premiumOnly && (
        <Flex
          position="absolute"
          top="10px"
          right="10px"
          alignItems="center"
          bg="rgba(0, 0, 0, 0.75)"
          borderRadius="16px"
          px="8px"
          py="4px"
        >
          <StarIcon boxSize="14px" color="#FFAA00" mr="4px" />
          <Text fontSize="12px" lineHeight="16px" fontWeight="600">
            Preview
          </Text>
        </Flex>
      )}
      <Box
        position="absolute"
        left="0"
        right="0"
        bottom="0"
        px="16px"
        pb="14px"
      >
        <Text
          as="h4"
          color="#FFFFFF"
          fontSize="17px"
          lineHeight="22px"
          fontWeight="700"
          mb="2px"
          noOfLines={1}
        >
          {readingOrder.title}
        </Text>
        <Text color="#C5CEE0" fontSize="13px" lineHeight="17px" noOfLines={1}>
          {meta}
        </Text>
      </Box>
    </Box>
  );
};

export default DiscoverCard;
